export default __webpack_public_path__ + "static/media/Icon-02.39321666.svg";